import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

function mainPhotoBlock(role) {
    return axios.get(`${url}/order/main_photo_block/` + role)
        .then(response => {
            return {
                mainPhotoBlock: response.data,
                meta: response.data.meta
            };
        });
}

function historyBlock(role) {
    return axios.get(`${url}/order/order_history_block/` + role)
        .then(response => {
            return {
                historyBlock: response.data,
                meta: response.data.meta
            };
        });
}

function prevOrdersBlock(role) {
    return axios.get(`${url}/order/prev_orders_block/` + role)
        .then(response => {
            return {
                prevOrdersBlock: response.data,
                meta: response.data.meta
            };
        });
}

function infoBlock(role) {
    return axios.get(`${url}/order/order_info_block/` + role)
        .then(response => {
            return {
                infoBlock: response.data,
                meta: response.data.meta
            };
        });
}

function downtime(role) {
    return axios.get(`${url}/order/downtime/` + role)
        .then(response => {
            return {
                downtime: response.data,
                meta: response.data.meta
            };
        });
}

function countNewOrders(role) {
    return axios.get(`${url}/order/get_count_new_orders/` + role)
        .then(response => {
            return {
                countNewOrders: response.data,
                meta: response.data.meta
            };
        });
}


function downloadExample(params) {
    const payload = params;
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/order/order_info_block`, payload, options)
        .then(response => {
            return {
                downloadExample: response.data
            };
        });
}

function getNewOrder(params) {
    const payload = params.formData;
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/order/newOrder/` + params.role, payload, options)
        .then(response => {
            return {
                getNewOrder: response.data
            };
        });
}

function submitOrder(params) {
    let role = params.role;
    const payload = params.formData;
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/order/admin_checked/` + role, payload, options)
        .then(response => {
            return {
                submitOrder: response.data
            };
        });
}

function submitComments(params) {
    let role = params.role;
    const payload = params.formData;
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/order/admin_reDone/` + role, payload, options)
        .then(response => {
            return {
                submitComments: response.data
            };
        });
}

function submitProblem(params) {
    let role = params.role;
    const payload = params.formData;
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/order/problem/` + role, payload, options)
        .then(response => {
            return {
                submitProblem: response.data
            };
        });
}

function submitFile(params) {
    let role = params.role;
    const payload = params.formData;
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/order/done/` + role, payload, options)
        .then(response => {
            return {
                submitFile: response.data
            };
        });
}

function whichRetoucher() {
    return axios.get(`${url}/order/whichretoucher`)
        .then(response => {
            return {
                whichRetoucher: response.data,
            };
        });
}

function writeRejected(params) {
    const payload = params;
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/order/write_rejected`, payload, options)
        .then(response => {
            return {
                writeRejected: response.data
            };
        });
}


export default {
    mainPhotoBlock,
    historyBlock,
    prevOrdersBlock,
    infoBlock,
    downtime,
    downloadExample,
    getNewOrder,
    submitOrder,
    submitComments,
    submitProblem,
    submitFile,
    whichRetoucher,
    writeRejected,
    countNewOrders
};